import { boot } from 'quasar/wrappers'
import type { PluginOptions } from 'vue-gtag'
import VueGtag from 'vue-gtag'

export default boot(({ app, router }) => {
  app.use(VueGtag, {
    config: { id: 'G-19LMVGJGJW' },
    appName: 'Analytics',
    pageTrackerScreenviewEnabled: true,
  } as PluginOptions, router)
})
